import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Landing from '../components/Landing'

import pic01 from '../assets/images/pic01.png'
import pic02 from '../assets/images/pic03.png'
import pic03 from '../assets/images/pic04.png'
import pic04 from '../assets/images/pic05.png'
import pic05 from '../assets/images/pic06.png'
import pic06 from '../assets/images/pic07.png'
import pic07 from '../assets/images/pic08.png'
import pic08 from '../assets/images/pic09.png'
import pic09 from '../assets/images/pic10.png'
import pic10 from '../assets/images/pic11.png'
import pic11 from '../assets/images/pic00.png'
import pic13 from '../assets/images/pic12.png'
import pic14 from '../assets/images/pic13.png'
import pic15 from '../assets/images/pic14.png'
import pic16 from '../assets/images/pic15.png'
import pic17 from '../assets/images/pic16.png'
import pic18 from '../assets/images/pic17.png'
import pic19 from '../assets/images/pic18.png'
import pic20 from '../assets/images/pic19.png'
import pic21 from '../assets/images/pic20.png'
import pic22 from '../assets/images/pic21.png'
import pic23 from '../assets/images/pic22.png'
import pic24 from '../assets/images/pic23.png'
import pic25 from '../assets/images/pic24.png'
import pic27 from '../assets/images/pic26.png'
import pic28 from '../assets/images/pic27.png'
import pic29 from '../assets/images/pic28.png'
import pic30 from '../assets/images/pic29.png'
import pic31 from '../assets/images/pic30.png'
import pic32 from '../assets/images/pic31.png'
import pic33 from '../assets/images/pic32.png'
import pic34 from '../assets/images/pic33.png'
import pic35 from '../assets/images/pic34.png'
import pic36 from '../assets/images/pic35.png'
import pic37 from '../assets/images/pic36.png'
import pic38 from '../assets/images/pic37.png'


const Elements = (props) => (
    <Layout>
        <Helmet>
            <title>Umair Zaki | My Skills</title>
            <meta name="description" content="Landing Page" />
        </Helmet>
        <Landing />

        <div id="main" className="alt">

            <section id="one">
                <div className="inner">
                                <div id="main">
                                <div className="box alt">
                                    <div className="grid-wrapper">
                                        <div className="col-4"><span className="image fit"><img src={pic08} alt="" /><h6>Python</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic09} alt="" /><h6>Numpy</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic10} alt="" /><h6>Pandas</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic07} alt="" /><h6>Matplotlib</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic06} alt="" /><h6>Neural Network</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic05} alt="" /><h6>Deep Learning</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic02} alt="" /><h6>Keras</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic01} alt="" /><h6>Scikit Learn</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic03} alt="" /><h6>TensorFlow</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic04} alt="" /><h6>Artificial Intelligence</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic11} alt="" /><h6>HTML5</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic13} alt="" /><h6>CSS3</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic14} alt="" /><h6>SASS</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic15} alt="" /><h6>Java Script</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic17} alt="" /><h6>NodeJS</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic16} alt="" /><h6>React</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic18} alt="" /><h6>Gatsby</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic19} alt="" /><h6>NPM</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic20} alt="" /><h6>Flask</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic21} alt="" /><h6>Terraform</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic22} alt="" /><h6>Windows</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic23} alt="" /><h6>Ubuntu</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic24} alt="" /><h6>Git</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic25} alt="" /><h6>Docker</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic27} alt="" /><h6>Kubernetes</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic28} alt="" /><h6>Jupyter Notebook</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic29} alt="" /><h6>Visual Studio</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic30} alt="" /><h6>GraphQl</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic31} alt="" /><h6>MongoDB</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic32} alt="" /><h6>Postman</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic38} alt="" /><h6>MySQL</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic33} alt="" /><h6>Rust</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic34} alt="" /><h6>Lean Startup</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic35} alt="" /><h6>Agile</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic36} alt="" /><h6>DevOps</h6></span></div>
                                        <div className="col-4"><span className="image fit"><img src={pic37} alt="" /><h6>Desing Thinking</h6></span></div>
                                        
                                       
                                    </div>
                                </div>
                                </div>
                            
                </div>
            </section>

        </div>

    </Layout>
)

export default Elements